import { useTranslation } from "react-i18next";
import { Quote, Star } from "lucide-react";

interface Testimonial {
  quote: string;
  name: string;
  role: string;
  initials: string;
}

export const Testimonials = () => {
  const { t } = useTranslation();

  const items = t("landing.testimonials.items", { returnObjects: true }) as Testimonial[];

  return (
    <section className="container mx-auto px-4 py-24 relative">
      <div className="text-center max-w-2xl mx-auto mb-14">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-pitch text-xs uppercase tracking-widest text-primary mb-5">
          <Star className="h-3 w-3 fill-primary" /> {t("landing.testimonials.badge")}
        </div>
        <h2 className="text-3xl md:text-5xl font-bold mb-4">
          {t("landing.testimonials.title")}{" "}
          <span className="text-primary">{t("landing.testimonials.title2")}</span>
        </h2>
        <p className="text-pitch-cream/65">{t("landing.testimonials.subtitle")}</p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
        {items.map((item, i) => (
          <figure
            key={i}
            className="relative border border-pitch rounded-2xl p-7 bg-white/[0.02] backdrop-blur transition-colors hover:bg-white/[0.04]"
          >
            <Quote className="absolute top-5 right-5 h-6 w-6 text-primary/20" aria-hidden />
            <div className="flex gap-0.5 mb-4" aria-hidden>
              {Array.from({ length: 5 }).map((_, s) => (
                <Star key={s} className="h-3.5 w-3.5 fill-primary text-primary" />
              ))}
            </div>
            <blockquote className="text-pitch-cream/85 text-[0.95rem] leading-relaxed mb-6">
              &ldquo;{item.quote}&rdquo;
            </blockquote>
            <figcaption className="flex items-center gap-3">
              <div className="h-10 w-10 rounded-full bg-gradient-to-br from-primary to-primary/60 text-primary-foreground flex items-center justify-center font-bold text-sm">
                {item.initials}
              </div>
              <div>
                <div className="font-semibold text-sm">{item.name}</div>
                <div className="text-pitch-cream/55 text-xs">{item.role}</div>
              </div>
            </figcaption>
          </figure>
        ))}
      </div>

      <p className="mt-8 text-center text-xs text-pitch-cream/35">
        {t("landing.testimonials.disclaimer")}
      </p>
    </section>
  );
};
